import React, { Component } from "react";
import logo from "../../assets/image/logo.png";
export default class Header extends Component {
  render() {
    return (
      <>
        <header className="section-header">
          <section className="header-main shadow-sm bg-white">
            <div className="container-sm py-3">
              <div className="row align-items-center">
                <div className="d-flex align-items-center">
                  <a href="/" className="brand-wrap mb-0">
                    <img
                      alt="Narayani Concept"
                      className="img-fluid"
                      src={logo}
                    />
                  </a>
                  <h4 className="brand-name text-primary">Narayani Concept</h4>
                  {/* brand-wrap.// */}
                </div>
                {/* <div className="col-3 d-flex align-items-center m-none">
                  <div className="dropdown mr-3">
                    <a
                      className="text-dark dropdown-toggle d-flex align-items-center"
                      href="#"
                      id="navbarDropdown"
                    >
                      <div>
                        <span className="material-icons mr-2 p-2">place</span>
                      </div>
                      <div>
                        <p className="text-muted mb-0 small">Select Location</p>
                        Jawaddi Ludhiana...
                      </div>
                    </a>
                    <div
                      className="dropdown-menu p-0 drop-loc"
                      aria-labelledby="navbarDropdown"
                    >
                      <div className="country">
                        <div className="search_location bg-primary p-3 text-right">
                          <div className="input-group rounded shadow-sm overflow-hidden">
                            <div className="input-group-prepend">
                              <button className="border-0 btn btn-outline-secondary text-dark bg-white btn-block">
                                <span className="material-icons">search</span>
                              </button>
                            </div>
                            <input
                              type="text"
                              className="shadow-none border-0 form-control"
                              placeholder="Enter Your Location"
                            />
                          </div>
                        </div>
                        <div className="p-3 border-bottom">
                          <a href="home.html" className="text-decoration-none">
                            <p className="font-weight-bold text-primary m-0 d-inline">
                              <span className="material-icons">near_me</span>{" "}
                              New York, USA
                            </p>
                          </a>
                        </div>
                        <div className="filter">
                          <h6 className="px-3 py-3 bg-light m-0 border-bottom">
                            Choose your country
                          </h6>
                          <div className="custom-radio">
                            <input
                              type="radio"
                              name="location"
                              className="custom-control-input"
                              id="customRadio1"
                            />
                            <label
                              className="custom-control-label py-3 w-100 px-3"
                              htmlFor="customRadio1"
                            >
                              Afghanistan
                            </label>
                          </div>
                          <div className="custom-control  border-bottom px-0 custom-radio">
                            <input
                              type="radio"
                              id="customRadio2"
                              name="location"
                              className="custom-control-input"
                              defaultChecked
                            />
                            <label
                              className="custom-control-label py-3 w-100 px-3"
                              htmlFor="customRadio2"
                            >
                              India
                            </label>
                          </div>
                          <div className="custom-control  border-bottom px-0 custom-radio">
                            <input
                              type="radio"
                              id="customRadio3"
                              name="location"
                              className="custom-control-input"
                            />
                            <label
                              className="custom-control-label py-3 w-100 px-3"
                              htmlFor="customRadio3"
                            >
                              USA
                            </label>
                          </div>
                          <div className="custom-control  border-bottom px-0 custom-radio">
                            <input
                              type="radio"
                              id="customRadio4"
                              name="location"
                              className="custom-control-input"
                            />
                            <label
                              className="custom-control-label py-3 w-100 px-3"
                              htmlFor="customRadio4"
                            >
                              Australia
                            </label>
                          </div>
                          <div className="custom-control  border-bottom px-0 custom-radio">
                            <input
                              type="radio"
                              id="customRadio5"
                              name="location"
                              className="custom-control-input"
                            />
                            <label
                              className="custom-control-label py-3 w-100 px-3"
                              htmlFor="customRadio5"
                            >
                              Japan
                            </label>
                          </div>
                          <div className="custom-control  px-0 custom-radio">
                            <input
                              type="radio"
                              id="customRadio6"
                              name="location"
                              className="custom-control-input"
                            />
                            <label
                              className="custom-control-label py-3 w-100 px-3"
                              htmlFor="customRadio6"
                            >
                              China
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* col.// */}
                {/* <div className="col-8">
                  <div className="d-flex align-items-center justify-content-end pr-5">
                    <a className="headerMenu text-dark">
                      <div className="d-flex align-items-center">
                        <span className="material-icons h6 mr-2 mb-0">
                          search
                        </span>
                        Search
                      </div>
                    </a>
                    <a
                      href="offers.html"
                      className="headerMenu text-white btn bg-primary m-none"
                    >
                      <div className=" d-flex align-items-center">
                        <span className="material-icons h6 mr-2 mb-0">
                          album
                        </span>
                        <span>Offers</span>
                      </div>
                    </a>
                    <a
                      href="login.html"
                      className="headerMenu text-dark m-none"
                    >
                      <div className=" d-flex align-items-center">
                        <span className="material-icons h6 mr-2 mb-0">
                          people
                        </span>
                        <span>Sign in</span>
                      </div>
                    </a>
                    <div className="headerMenu dropdown mr-4 m-none">
                      <a
                        href="#"
                        className="dropdown-toggle text-dark py-3 d-block"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <img
                          alt="#"
                          src="img/user/1.jpg"
                          className="img-fluid rounded-circle header-user mr-2 header-user"
                        />
                        Hi Osahan
                      </a>
                      <div
                        className="dropdown-menu dropdown-menu-right"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a className="dropdown-item" href="profile.html">
                          My account
                        </a>
                        <a className="dropdown-item" href="faq.html">
                          Delivery support
                        </a>
                        <a className="dropdown-item" href="contact-us.html">
                          Contant us
                        </a>
                        <a className="dropdown-item" href="terms.html">
                          Term of use
                        </a>
                        <a className="dropdown-item" href="privacy.html">
                          Privacy policy
                        </a>
                        <a className="dropdown-item" href="login.html">
                          Logout
                        </a>
                      </div>
                    </div>
                    <a href="checkout.html" className="headerMenu text-dark">
                      <div className=" d-flex align-items-center">
                        <span className="material-icons h6 mr-2 mb-0">
                          shopping_cart
                        </span>
                        <span>Cart</span>
                      </div>
                    </a>
                    <a className="toggle" href="#">
                      <span />
                    </a>
                  </div>
                </div> */}
              </div>
              {/* row.// */}
            </div>
            {/* container.// */}
          </section>
          {/* header-main .// */}
        </header>
        <div className="d-none">
          <div className="bg-primary p-3 d-flex align-items-center">
            <a href="/" className="brand-wrap mb-0">
              <img alt="Narayani Concept" className="img-fluid" src={logo} />
            </a>
            <h4 className="brand-name text-white">Narayani Concept</h4>
          </div>
        </div>
      </>
    );
  }
}
